module.exports = __webpack_public_path__ + "media/common/images/badges/gray/dotahovac_2-4f70971a436a89737a675fa51ff9370d.svg";